import dayjs, { Dayjs } from 'dayjs'

import { FormField } from '@cloudscape-design/components'

// @ts-ignore
import { DatePicker } from '@mui/x-date-pickers'
// import { MobileDatePicker } from '@mui/x-date-pickers'

export type DateInputProps = {
    label: string,
    value: string, 
    onChange?: (value: string) => void, 
    validate?: (value: string, label: string) => boolean,
    readOnly: boolean, 
    [rest: string]: any,
}

export default (props: DateInputProps) => {

    // if (readOnly) {
    //     return (
    //         <div>
    //             {label + ': '}
    //             <b style={{width: '100px'}}>{value}</b>
    //         </div> 
    //     ) 
    // }

    dayjs.extend(require('dayjs/plugin/localizedFormat'))

    const valid = props.readOnly ? true : props.validate ? props.validate(props.value, props.label) : true

    const setDay = (date: Dayjs | null) => {
        // setValue(date)
        props.onChange && props.onChange(date?.format("YYYY-MM-DD") || '')
    }

    return (
        <FormField label={props.label} info={props.validate ? '' : 'Optional'} >
            <DatePicker readOnly={props.readOnly} valid={valid}
            // <MobileDatePicker readOnly={props.readOnly} valid={valid}
                value={ !props.value ? null : dayjs(props.value) }
                onChange={setDay}
                sx={{"& .MuiOutlinedInput-root": {borderRadius: 2, borderColor: 'black'}, "& .MuiOutlinedInput-input": { padding: (5/8), pl: 1 } }}
                {...props.rest}
            />
        </FormField>
    )
}